import { createWebHistory, createRouter } from "vue-router";
import About from "@/pages/About.vue";

const routes = [
  {
    path: "/",
    name: "about",
    component: About,
  },
  {
    path: "/krikscioniu-partija",
    name: "chrstian-party",
    component: () =>
      import(/* webpackChunkName: "chrstian-party" */ './pages/ChristianParty.vue')
  },
  {
    path: "/straipsniai",
    name: "articles",
    component: () =>
      import(/* webpackChunkName: "articles" */ './pages/Articles.vue')
  },
  {
    path: "/straipsniai/page/2",
    name: "articles-2",
    component: () =>
      import(/* webpackChunkName: "articles-2" */ './pages/Articles2.vue')
  },
  {
    path: "/straipsniai/page/3",
    name: "articles-3",
    component: () =>
      import(/* webpackChunkName: "articles-3" */ './pages/Articles3.vue')
  },
  {
    path: "/kontaktai",
    name: "contacts",
    component: () =>
      import(/* webpackChunkName: "contacts" */ './pages/Contacts.vue')
  },
  // LINKS TO ARTICLES
  {
    path: "/2012/01/vaiku-islaikymas",
    name: "vaiku-islaikymas",
    component: () =>
      import(/* webpackChunkName: "vaiku-islaikymas" */ './pages/Articles/VaikuIslaikymas.vue')
  },
  {
    path: "/2011/02/sakieciai-susitiko-su-gediminu-vagnoriumi",
    name: "susitikimas-su-vagnoriumi",
    component: () =>
      import(/* webpackChunkName: "susitikimas-su-vagnoriumi" */ './pages/Articles/SusitikimasSuVagnoriumi.vue')
  },
  {
    path: "/2011/01/krikscioniu-partija-%e2%80%9ekasos-aparatai-turguose-%e2%80%93-nesavalaikis-siulymas%e2%80%9c/",
    name: "kasos-aparatai",
    component: () =>
      import(/* webpackChunkName: "kasos-aparatai" */ './pages/Articles/KasosAparatai.vue')
  },
  {
    path: "/2011/01/sausio-13-osios-lietuvos-pilieciu-zygdarbis/",
    name: "sausio-tryl",
    component: () =>
      import(/* webpackChunkName: "sausio-tryl" */ './pages/Articles/SausioTryl.vue')
  },
  {
    path: "/2011/01/giminystes-rysiu-reiksme-teisiniuose-reikaluose/",
    name: "giminystes-rysiai",
    component: () =>
      import(/* webpackChunkName: "giminystes-rysiai" */ './pages/Articles/GiminystesRysiai.vue')
  },
  {
    path: "/2011/01/kokiais-atvejais-dovanojimo-sutarti-butina-tvirtinti-notariskai/",
    name: "dovanojimo-sutartis",
    component: () =>
      import(/* webpackChunkName: "dovanojimo-sutartis" */ './pages/Articles/DovanojimoSutartis.vue')
  },
  {
    path: "/2010/12/sakiuose-ikurtas-krikscioniu-partijos-skyrius/",
    name: "ikurta-partija",
    component: () =>
      import(/* webpackChunkName: "ikurta-partija" */ './pages/Articles/IkurtaPartija.vue')
  },
  {
    path: "/2010/12/kaip-elgtis-nutraukiant-santuoka/",
    name: "santuokos-nutraukimas",
    component: () =>
      import(/* webpackChunkName: "santuokos-nutraukimas" */ './pages/Articles/SantuokosNutraukimas.vue')
  },
  {
    path: "/2010/12/su-sv-kaledom",
    name: "sv-kaledos",
    component: () =>
      import(/* webpackChunkName: "sv-kaledos" */ './pages/Articles/SvKaledos.vue')
  },
  {
    path: "/2011/01/kas-tai-preliminarioji-sutartis",
    name: "preliminarioji-sutartis",
    component: () =>
      import(/* webpackChunkName: "preliminarioji-sutartis" */ './pages/Articles/PreliminariojiSutartis.vue')
  },
  {
    path: "/2010/12/sutuoktiniu-gyvenimas-skyrium-separacija",
    name: "separacija",
    component: () =>
      import(/* webpackChunkName: "separacija" */ './pages/Articles/Separacija.vue')
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(() => {
  window.scrollTo(0, 0)
})

export default router;